import { combineReducers } from 'redux';

import filters from './Filters';
import originCities from './OriginCities';
import popularCities from './PopularCities';
import pricings from './Pricings';
import status from './Status';

const namespace = 'explorer';
const reducerMap = {
    popularCities,
    filters,
    originCities,
    pricings,
    status,
};

const reducer = combineReducers(reducerMap);

export default {
    [namespace]: reducer,
};
